<template>
  <div id="toast">
    <transition>
      <div v-if="show" class="alert" :class="{'alert-success': !error, 'alert-danger': error}" role="alert">
          {{message}}
          <button type="button" class="btn btn-light btn-sm" style="border-radius:50px;border-radius: 50px;position: absolute;top:-15px;right:0;" @click="close">
              <i class="fa fa-times" aria-hidden="true"></i>
          </button>
      </div>
    </transition>
  </div>
</template>

<style scoped>
.v-enter-active, .v-leave-active {
  transition: opacity .5s;
}
.v-enter, .v-leave-to {
  opacity: 0;
}
</style>

<script>

export default {
  name: "toast",
  props: {
  },
  data() {
    return {
      show: false,
      message: '',
      error: false,
    }
  },
  watch: {
  },
  mounted() {
  },
  methods: {
    showToast(message, time, error) {
      time = time ? time : 3000
      this.show = true
      this.message = message
      this.error = error ? true: false
      if(!error){
        setTimeout(function(){
            this.show = false
        }.bind(this), time);
      }
    },
    close (){
      this.show = false
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/assets/js/components/Toast.vue